<template>
  <div class="dateSingleOrRange">
    <RadioTop :options="['今日', '明日','自訂']" :defaultValue="type" @input="typeChange($event)" @same="same"/>
    <div class="pop" v-show="show">
      <DateInput :style="{height: '40px', width: '230px'}"  v-if="show"
      :defaultValue="date" @input="date=$event"/>
      <button class="closeBtn" @click="show=false"></button>
    </div>
  </div>
</template>

<script>
import DateInput from '../input/date.vue'
import RadioTop from '../radio/r1.vue'
export default {
  props: ['defaultValue'],
  name: 'dateSingleOrRange',
  components: {
    RadioTop,
    DateInput
  },
  data () {
    return {
      type: '今日',
      show: false,
      date: this.moment().format('yyyy-MM-DD')
    }
  },
  watch: {
    defaultValue: {
      handler () {
        const today = this.moment().format('yyyy-MM-DD')
        const tomorrow = this.moment().add(1, 'day').format('yyyy-MM-DD')
        if (this.defaultValue === today) {
          this.type = '今日'
          this.date = today
        } else if (this.defaultValue === tomorrow) {
          this.type = '明日'
          this.date = tomorrow
        } else {
          this.type = '自訂'
        }
        console.log(this.type)
      },
      immediate: true
    },
    date: {
      handler () {
        if (this.date) {
          this.show = false
          this.$emit('input', this.date)
        }
      },
      deep: true
    }
  },
  methods: {
    typeChange (ev) {
      console.log('typeChange', ev)
      const today = this.moment().format('yyyy-MM-DD')
      const tomorrow = this.moment().add(1, 'day').format('yyyy-MM-DD')
      if (ev === '今日') {
        this.type = '今日'
        this.show = false
        this.$emit('input', today)
      } else if (ev === '明日') {
        this.type = '明日'
        this.show = false
        this.$emit('input', tomorrow)
      } else if (ev === '自訂') {
        this.type = '自訂'
        this.show = true
      }
    },
    same (ev) {
      console.log('same', ev)
      if (ev === '自訂') {
        this.show = true
      }
    }
  }
}
</script>
<style lang="scss">
.dateSingleOrRange {
#setDate-wrapper #setDate-input {
  border-color: #C4C4C4;
}
  #setDateRange-wrapper #setDateRange-input {
    height: 40px;
    letter-spacing: 0;
  }
}
</style>
<style lang="scss" scoped>
.closeBtn {
  margin-left: 6px;
  width: 36px;
  height: 36px;
  border: none;
  background-color: var(--color-pri);
  mask-image: url(/close.svg);
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
}
.dateSingleOrRange {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 14px;
  position: relative;
}
.pop {
  position: absolute;
  top: 42px;
  height: 60px;
  right: 0;
  padding: 10px;
  background: #FFFFFF;
  box-shadow: 4px 0px 4px rgba(0, 0, 0, 0.25), -2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  display: flex;
  align-items: center;
}
</style>
